export const ComponentMap = {
    TEXT: 'CnInput',
    LONG_TEXT: 'CnInputTextArea',
    NUMBER: 'CnInput',
};
const excludeFormFields = [
    'campus',
    'space',
    'title',
    'content',
    'attachments',
];
/**
 * 把后端返回的数据转换成适合前端使用的格式
 */
export const getFormScheme = async (formConfig) => {
    const { caseFormOpenVO } = formConfig;
    const { extInfo: extInfoDto, caseFormFieldList } = caseFormOpenVO;
    const extInfo = extInfoDto?.extFieldSceneMap?.CREATE?.extFieldMap || {};
    const fieldList = caseFormFieldList || [];
    const schema = {};
    let hasMerchantCnMemberId = false;
    fieldList.forEach((it) => {
        const { code, name, type } = it;
        const componentName = ComponentMap[type];
        const curExtInfo = extInfo[code];
        if (!componentName || excludeFormFields.includes(code)) {
            return;
        }
        const { required, readOnly, visible } = curExtInfo || {};
        // 只读的 和 不展示的 不在表单中展示
        if ((curExtInfo && !visible) || readOnly) {
            if (code === 'merchantCnMemberId') {
                hasMerchantCnMemberId = true;
            }
            return;
        }
        schema[code] = {
            title: name,
            required,
            'x-decorator': 'CnFormItem',
            'x-component': componentName,
            'x-read-only': readOnly,
        };
    });
    return { schema, hasMerchantCnMemberId };
};
